import { Link, useNavigate, useParams } from 'react-router-dom'
import { ICONS } from '../../../common/constants'
import fetchAPI from '../../../common/fetchAPI'
import useToast from '../../../common/hooks/useToast'
import useModal from '../../../common/hooks/useModal'
import ConfirmModalContent from '../../../components/common/ConfirmModalContent'
import ActionsDropdown from '../../../components/common/ActionsDropdown'
import SectionContainer from '../../../components/common/SectionContainer'
import DataFormNew from '../../../components/common/DataFormNew'
import InlineStack from '../../../components/common/InlineStack'

export default function EditProject() {
    const { projectId } = useParams()
    const setToast = useToast()
    const navigate = useNavigate()
    const { setModal, setModalLoading, isModalLoading } = useModal()

    const inputs = [
        {
            key: 'title',
            label: 'Title',
            required: true,
            autoComplete: 'off',
        },
        {
            key: 'descriptionHtml',
            label: 'Description',
            type: 'html',
            id: 'form-description',
        },
        {
            key: 'phases',
            type: 'liveSearchAddItems',
            label: 'Phases',
            canAddNewItem: true,
            id: 'form-phases',
            getItemText: (item) => item.title,
            getItemBody: (text) => ({ title: text }),
            fields: [
                {
                    column: 1,
                    getValue: (item) => item.title,
                },
            ],
            infoBottom: 'Removing phases may affect the tasks in this project.',
        },
    ]

    function mapItemToData(item) {
        return {
            title: item.title,
            descriptionHtml: item.descriptionHtml || '',
            phases: item.phases,
        }
    }

    async function getBody(data) {
        const body = { ...data }
        return body
    }

    function onDelete() {
        setModal(
            <ConfirmModalContent
                onConfirm={async () => {
                    if (isModalLoading) return
                    setModalLoading(true)

                    const { error } = await fetchAPI(
                        `/v1/tasks/projects/${projectId}`,
                        {},
                        'DELETE',
                    )

                    setModalLoading(false)
                    setModal(null)

                    if (error) {
                        setToast(error, 'alert')
                        return
                    }

                    navigate('/projects')
                    setToast('Project deleted')
                }}
            />,
            'Are you sure you want to delete this project?',
        )
    }

    return (
        <>
            <SectionContainer>
                <InlineStack gap={'sm'} justifyEnd>
                    <ActionsDropdown
                        actions={[
                            {
                                title: 'Delete',
                                onClick: onDelete,
                                type: 'alert',
                                icon: ICONS.TRASH_RED,
                            },
                        ]}
                    />
                </InlineStack>
            </SectionContainer>
            <SectionContainer>
                <DataFormNew
                    url={`/v1/tasks/projects/${projectId}?fields[]=title&fields[]=descriptionHtml&fields[]=phases`}
                    method="PATCH"
                    submitText="Save"
                    submitToast="Project updated"
                    inputs={inputs}
                    mapItemToData={mapItemToData}
                    getBody={getBody}
                    mainButton
                    mutationRegexes={[/\/v1\/tasks\/projects/]}
                    onlySaveChanges
                />
            </SectionContainer>
        </>
    )
}
